import { Box } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import "react-h5-audio-player/lib/styles.css";
import { SiteContext } from "../../contexts";

const { REACT_APP_API_URL } = process.env;

export default function AudioPlayer({ id, items, moduleInstance }) {
  const {
    site: { id: siteId, userId },
  } = useContext(SiteContext);

  // State to track listening timers for each audio element
  const [listenTimers, setListenTimers] = useState({});
  const [trackedListens, setTrackedListens] = useState(new Set());

  let moduleInstanceId = null;
  try {
    if (moduleInstance?.props?.id) {
      moduleInstanceId = moduleInstance.props.id
        .replace("{{", "")
        .replace("_id}}", "");
    }
  } catch (err) {
    console.error(err);
  }

  const trackListen = (url) => {
    fetch(`${REACT_APP_API_URL}/stats/event`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        clientId: userId,
        siteId,
        type: "audio-player",
        additionalInfo: `${moduleInstanceId}-${url}`,
      }),
    });
  };

  // Handle audio play event
  const handleAudioPlay = (audioSrc) => {
    // Clear any existing timer for this audio
    if (listenTimers[audioSrc]) {
      clearTimeout(listenTimers[audioSrc]);
    }

    // Don't track if already tracked for this session
    if (trackedListens.has(audioSrc)) {
      return;
    }

    // Set a 3-second timer
    const timer = setTimeout(() => {
      trackListen(audioSrc);
      setTrackedListens((prev) => new Set(prev).add(audioSrc));
    }, 3000);

    setListenTimers((prev) => ({ ...prev, [audioSrc]: timer }));
  };

  // Handle audio pause/ended event
  const handleAudioPause = (audioSrc) => {
    if (listenTimers[audioSrc]) {
      clearTimeout(listenTimers[audioSrc]);
      setListenTimers((prev) => {
        const newTimers = { ...prev };
        delete newTimers[audioSrc];
        return newTimers;
      });
    }
  };

  // Cleanup timers on unmount
  useEffect(
    () => () => {
      Object.values(listenTimers).forEach((timer) => clearTimeout(timer));
    },
    [listenTimers]
  );

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }} id={id}>
      {items.map((item) => (
        <Box key={item.src} sx={{ marginBottom: 2 }}>
          {item.description?.length && (
            <div dangerouslySetInnerHTML={{ __html: item.description }} />
          )}
          {(item.src || item.dropboxUrl) && (
            <audio
              style={{ width: "100%" }}
              controls
              onPlay={() => {
                trackListen(item.src || item.dropboxUrl);
              }}
            >
              <source
                src={
                  item.dropboxUrl?.length
                    ? `${item.dropboxUrl}&raw=1`
                    : `/api/uploads/${item.src}?range=true`
                }
                type="audio/mpeg"
              />
              <track kind="captions" />
            </audio>
          )}
        </Box>
      ))}
    </Box>
  );
}
